import { extendTheme } from '@chakra-ui/react';

import {
  BG_PRIMARY,
  BG_SECONDARY,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  TEXT_ALTERNATIVE,
  BG_LAYER,
  BG_ALTERNATIVE,
} from '@/constants/colors';
import { FONT_FAMILY } from '@/constants/default-props';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://cha
 kra-ui.com/guides/using-fonts
 */
const theme = {
  config: {
    initialColorMode: 'light',
    useSystemColorMode: false,
  },
  fonts: {
    heading: `'AstonScript', cursive;`,
    subHeading: `'Bodoni', serif;`,
    subHeading_lv2: `'Bodoni', serif;`,
    body: FONT_FAMILY.body,

    // for generator purpose
    jost: `'Jost', sans-serif;`,
    delafield: `'Mrs Saint Delafield', cursive;`,
  },
  fontSizes: {
    heading: '24px',
    subHeading: '18px',
    subHeading_lv2: '18px',
    body: '18px',
  },
  fontWeights: {
    heading: 400,
    subHeading: 400,
    subHeading_lv2: 800,
    body: 800,
  },
  styles: {
    global: {
      ':root': {
        '--fontItalic-heading': '',
        '--fontItalic-subHeading': '',
        '--fontItalic-subHeading_lv2': '',
        '--fontItalic-body': '',
      },
    },
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    bgLayer: BG_LAYER,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    alternativeColorText: TEXT_ALTERNATIVE,
    transparent: 'transparent',
  },
  // override components
  components: {
    Heading: {
      baseStyle: {
        letterSpacing: 'normal',
      },
    },
  },
};

export default extendTheme(theme);
